export const ADD_INBOX = 'ADD_INBOX';
export const APPEND_INBOX = 'APPEND_INBOX';

export function addInbox(options) {
    return { type: ADD_INBOX, options };
}

export function appendInbox(options) {
    return { type: APPEND_INBOX, options };
}
